module.exports = __webpack_public_path__ + "img/0xcf9f991b14620f5ad144eec11f9bc7bf08987622.7a608a41.png";